module.exports = __webpack_public_path__ + "media/stop.6b403966.wav";